export default __webpack_public_path__ + "assets/images/3372478787140332bc199f5d3fecc196.svg";